import discardSkypeOption from './data/mutators/discardSkypeOptions';
import saveSkypeOption from './orchestration/saveSkypeOptions';
import isSkypeOptionDirty from './utils/isSkypeOptionDirty';
import SkypeNotificationFull from './view/SkypeNotificationFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
var SkypeNotificationOption = {
    key: 'skypeNotifications',
    titleStringKey: 'optionSubcategory_notifications',
    searchTermsStringKey: 'optionSubcategory_notifications',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SkypeNotificationFull, null); },
        isDirty: isSkypeOptionDirty,
        onSave: saveSkypeOption,
        onDiscard: discardSkypeOption,
    },
    isHidden: function () {
        return !isControlFeatureEnabled('fwk-skypeConsumer') &&
            !isControlFeatureEnabled('fwk-skypeBusiness');
    },
};
export default SkypeNotificationOption;
//# sourceMappingURL=SkypeNotificationOption.js.map